/* src/sb-tools/typescript/components/loader/loader.component.scss */
:host {
  display: block;
  min-height: 40px;
  padding: 4px 0;
}
.loader {
  position: relative;
  margin: 0 auto;
  width: 30px;
}
.loader:before {
  content: "";
  display: block;
  padding-top: 100%;
}
.loader.small {
  width: 20px;
}
.circular {
  animation: rotate 2s linear infinite;
  height: 100%;
  transform-origin: center center;
  width: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
}
.circular.blue {
  stroke: #4097ff;
}
.circular.white {
  stroke: white;
}
.path {
  stroke-dasharray: 1, 200;
  stroke-dashoffset: 0;
  animation: dash 1.5s ease-in-out infinite, color 6s ease-in-out infinite;
  stroke-linecap: round;
}
@keyframes rotate {
  100% {
    transform: rotate(360deg);
  }
}
@keyframes dash {
  0% {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -35px;
  }
  100% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -124px;
  }
}
/*# sourceMappingURL=loader.component.css.map */
